import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchData, fetchExport } from "./customerSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  createChangeHandler,
  getLabel,
  getLabelOnly,
  setOptionsMaster,
} from "../../utility";
import { CustomerTable } from "./CustomerTable";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { ViewMapsMarkerCustomer } from "../../utility/ViewMapsMarkerCustomer";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";

import { GoogleMap, InfoWindow, Marker, Polygon } from "@react-google-maps/api";
import {
  fetchSettingJourney,
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
} from "../setting-journey/settingJourneySlice";
import MultiSelectAll from "../../utility/MultiSelectAll";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const mapContainerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: -6.2088,
  lng: 106.8456,
};

const getRandomColor = () => {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
};

const polygonOptions = (fillColor) => ({
  fillColor: fillColor,
  fillOpacity: 0.4,
  strokeColor: fillColor,
  strokeOpacity: 0.8,
  strokeWeight: 2,
  clickable: true,
});

export const CustomerMaps = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const dataUser = useSelector(selectDataUser);
  const dataParam = useSelector(selectDataParam);

  const [selected, setSelected] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [sales, setSales] = useState([]);
  const [userPosition, setUserPosition] = useState(null);
  const [activePolygonIndexes, setActivePolygonIndexes] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      dispatch(resetData());
      await dispatch(fetchSettingJourney({ pageNo: 1, pageSize: -1 }));
    }
    fetchMyAPI();
  }, [dispatch]);

  // useEffect(() => {
  //   if (data && data.length > 0) {
  //     const initData = data.map((item, index) => {
  //       return {
  //         ...item,
  //         no: index + 1,
  //         color: getRandomColor(),
  //         locations: (item.customers || []).map((customer) => {
  //           return {
  //             ...customer,
  //             lat: parseFloat(customer.customer_latitude) || null,
  //             lng: parseFloat(customer.customer_longitude) || null,
  //           };
  //         }),
  //       };
  //     });

  //     setSales(data.map((option) => option["company_sales_code"]));
  //     setCustomer(initData);
  //   }
  // }, [data]);

  useEffect(() => {
    getUserPosition();
  }, []);

  const getUserPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userPos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setUserPosition(userPos);
        },
        (error) => {
          console.error("Error getting user position:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const filterValidLocations = (locations) => {
    if (!Array.isArray(locations)) {
      return [];
    }
    return locations.filter((location) => location.lat && location.lng);
  };

  const salesOptions = data?.map((item) => {
    return {
      ...item,
      color: getRandomColor(),
      value: item.company_sales_code,
      label: item.company_sales_name,
    };
  });

  const getValueOptions = (data) => {
    return data.map((val) => {
      return salesOptions.find((option) => option.value === val);
    });
  };

  const handleSalesChange = (selectedOptions) => {
    if (selectedOptions) {
      setSales(selectedOptions.map((option) => option["value"]));
      const updatedCustomers = selectedOptions.map((option) => ({
        ...option,
        locations: option.customers.map((customer) => ({
          ...customer,
          lat: parseFloat(customer.customer_latitude) || null,
          lng: parseFloat(customer.customer_longitude) || null,
        })),
      }));
      setCustomer(updatedCustomers);
    } else {
      setSales([]);
      setCustomer([]);
    }
  };

  const handlePolygonToggle = (index) => {
    setActivePolygonIndexes(
      (prevIndexes) =>
        prevIndexes.includes(index)
          ? prevIndexes.filter((i) => i !== index) // Remove the index if it exists
          : [...prevIndexes, index] // Add the index if it doesn't exist
    );
  };

  const getPolygonCenter = (paths) => {
    const latLngBounds = new window.google.maps.LatLngBounds();
    paths.forEach((path) => latLngBounds.extend(path));
    const center = latLngBounds.getCenter();
    return { lat: center.lat(), lng: center.lng() };
  };

  // Convex Hull Algorithm (Graham Scan)
  const convexHull = (points) => {
    if (points.length <= 1) return points;

    // Sort points lexicographically (by x and then by y)
    points.sort((a, b) => a.lng - b.lng || a.lat - b.lat);

    const cross = (o, a, b) =>
      (a.lng - o.lng) * (b.lat - o.lat) - (a.lat - o.lat) * (b.lng - o.lng);

    const lower = [];
    for (const p of points) {
      while (
        lower.length >= 2 &&
        cross(lower[lower.length - 2], lower[lower.length - 1], p) <= 0
      ) {
        lower.pop();
      }
      lower.push(p);
    }

    const upper = [];
    for (let i = points.length - 1; i >= 0; i--) {
      const p = points[i];
      while (
        upper.length >= 2 &&
        cross(upper[upper.length - 2], upper[upper.length - 1], p) <= 0
      ) {
        upper.pop();
      }
      upper.push(p);
    }

    upper.pop();
    lower.pop();

    return lower.concat(upper);
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Sales Area">
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Row>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              zoom={12}
              center={userPosition === null ? center : userPosition}
            >
              {customer.map((data, dataIndex) => {
                const { locations, color } = data;
                const validLocations = filterValidLocations(locations);
                const polygonCenter = getPolygonCenter(validLocations);
                const polygonLocations = convexHull(validLocations);

                return (
                  <React.Fragment key={dataIndex}>
                    {validLocations.map((location, index) => (
                      <Marker
                        key={`marker-${dataIndex}-${index}`}
                        position={location}
                        label={{
                          text: ` ${dataIndex + 1}`,
                          color: "black",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                        onMouseOver={() => setSelected(location)}
                        onMouseOut={() => setSelected(null)}
                        icon={{
                          path: window.google.maps.SymbolPath.CIRCLE,
                          fillColor: color,
                          fillOpacity: 1,
                          strokeColor: color,
                          strokeWeight: 1,
                          scale: 10,
                        }}
                      />
                    ))}

                    {/* Render polygon only if it is active */}
                    {activePolygonIndexes.includes(dataIndex) && ( // Check if the polygon index is active
                      <>
                        <Polygon
                          paths={polygonLocations}
                          options={polygonOptions(color)}
                        />
                        <Marker
                          position={polygonCenter}
                          label={{
                            text: ` ${dataIndex + 1}`,
                            color: color,
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                          icon={{
                            path: window.google.maps.SymbolPath.CIRCLE,
                            scale: 0,
                          }}
                        />
                      </>
                    )}
                  </React.Fragment>
                );
              })}

              {selected && (
                <InfoWindow
                  position={{ lat: selected.lat, lng: selected.lng }}
                  onCloseClick={() => setSelected(null)}
                >
                  <div>
                    <h3>{selected.customer_code}</h3>
                    <p>{selected.customer_store_name}</p>
                    <p>{selected.customer_address}</p>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          </Row>

          <Row className="mt-4">
            <Col sm={4}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales:</b>
                </Form.Label>
                <Col sm={9}>
                  <MultiSelectAll
                    options={salesOptions}
                    value={getValueOptions(sales)}
                    onChange={handleSalesChange}
                    placeholder="Select Sales..."
                  />
                </Col>
              </Form.Group>
            </Col>

            <Col sm={8}>
              {customer.length > 0 && (
                <Form.Group as={Row}>
                  <Form.Label column sm={2}>
                    <b>Area Sales</b>
                  </Form.Label>
                  <Col sm={10}>
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      {customer.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                            marginTop: "5px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <p style={{ margin: 0 }}>
                              <b>{item.company_sales_code}</b> <br />
                              {item.company_sales_name}
                            </p>
                          </div>
                          <span
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              backgroundColor: item.color,
                              marginLeft: "10px",
                            }}
                          />
                          <button
                            className="btn btn-icon btn-light btn-hover-danger btn-sm"
                            onClick={() => handlePolygonToggle(index)} // Pass the correct index for toggling
                            style={{ marginLeft: "10px" }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-danger">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Map/Position.svg"
                                )}
                              />
                            </span>
                          </button>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Form.Group>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};
